import React, { useContext } from 'react';
import { object, oneOfType, array } from 'prop-types';
import classNames from 'classnames/bind';

import ProductTabs from '../../components/ProductTabs';
import ProductAccordion from '../../components/ProductAccordion';
import { withTechnicalBulletin } from 'containers/withTechnicalBulletin';

import { WindowSizeContext } from 'context/WindowSizeContext';

import ProductTabsProvider from 'context/ProductTabsContext';

import styles from './ProductTabsContainer.module.scss';
const cx = classNames.bind(styles);

const ProductTabsContainer = ({ data, match, dataBulletins }) => {
  const { isMobile } = useContext(WindowSizeContext);

  return (
    <ProductTabsProvider>
      {isMobile ? (
        <ProductAccordion
          data={data}
          match={match}
          dataBulletins={dataBulletins}
          className={cx('accordion')}
        />
      ) : (
        <ProductTabs
          data={data}
          dataBulletins={dataBulletins}
          match={match}
          className={cx('tabs')}
        />
      )}
    </ProductTabsProvider>
  );
};

ProductTabsContainer.propTypes = {
  data: object.isRequired,
  dataBulletins: oneOfType([object, array]).isRequired,
  match: object.isRequired,
};

export default withTechnicalBulletin(ProductTabsContainer);



// WEBPACK FOOTER //
// ./src/pages/Product/containers/ProductTabsContainer/ProductTabsContainer.js